// extracted by mini-css-extract-plugin
module.exports = {"project-slider":"ProjectSlider_project-slider__h9bxm","project-card-container":"ProjectSlider_project-card-container__UxJWc"};